var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.modalVisible)?_c('ModalWrapper'):_vm._e(),(_vm.showOrientationAlert)?_c('ScreenOrientationAlert'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }